import { ReactNode } from "react";

import { css } from "@compiled/react";

import { ProductKeys } from "@atlassiansox/asc-stargate";

import { CrossFlowTouchpointProvider } from "@/components/cross-flow/touchpoint/context";
import { SiteSelectorContextProvider } from "@/components/site-selector-modal/site-selector-context";
import { SitesContextProvider } from "@/components/sites-provider";
import { GlobalFooter } from "@/patterns/global-footer/src/global-footer";

import ConfluenceSoftwareNav from "../../../../confluence-software-page/src/sections/confluence-navbar";

const minHeight = css({
    minHeight: 1000
});

export const SharedHeaderFooterContainer = ({
    children
}: {
    children: ReactNode;
}) => {
    return (
        <div css={minHeight}>
            <CrossFlowTouchpointProvider productKeys={[ProductKeys.CONFLUENCE]}>
                <ConfluenceSoftwareNav />
                <SitesContextProvider>
                    <SiteSelectorContextProvider
                        productKey={ProductKeys.CONFLUENCE}
                        analyticsPrefix="wac.showroom"
                        internalLinkAfterIdentity="/team-playbook/plays/choose-your-site"
                    >
                        <main id="content">{children}</main>
                    </SiteSelectorContextProvider>
                </SitesContextProvider>
                <GlobalFooter />
            </CrossFlowTouchpointProvider>
        </div>
    );
};

export const ConfluenceTemplateHeaderContainer = () => {
    return (
        <CrossFlowTouchpointProvider productKeys={[ProductKeys.CONFLUENCE]}>
            <SitesContextProvider>
                <SiteSelectorContextProvider
                    productKey={ProductKeys.CONFLUENCE}
                    analyticsPrefix="wac.showroom"
                    internalLinkAfterIdentity="/team-playbook/plays/choose-your-site"
                >
                    <ConfluenceSoftwareNav />
                </SiteSelectorContextProvider>
            </SitesContextProvider>
        </CrossFlowTouchpointProvider>
    );
};
